import { DateRangePreset } from './analytics.types';

export const dateRangePresets: { key: DateRangePreset; label: string }[] = [
  { key: '7d', label: 'Last 7 days' },
  { key: '30d', label: 'Last 30 days' },
  { key: '90d', label: 'Last 90 days' },
  { key: '6m', label: 'Last 6 months' },
  { key: '1y', label: 'Last year' },
  { key: 'custom', label: 'Custom' },
];